import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Droplet, Scissors, Sun } from 'lucide-react';
const services = [{
  id: 'lash-extensions',
  name: 'Lash Extensions',
  description: 'Diseño personalizado para tu forma de ojo',
  icon: Sparkles
}, {
  id: 'henna-brows',
  name: 'Henna Brows',
  description: 'Definición natural que dura semanas',
  icon: Droplet
}, {
  id: 'thread-eyebrows',
  name: 'Thread Eyebrows',
  description: 'Precisión sin dolor, forma perfecta',
  icon: Scissors
}, {
  id: 'tanning',
  name: 'Tanning',
  description: 'Luminosidad y color natural para tu piel',
  icon: Sun
}];
export function AboutIngri() {
  return <section id="nosotros" className="py-24 px-6 bg-cream text-ink" data-id="element-14">
      <div className="max-w-6xl mx-auto" data-id="element-15">
        {/* Artist Intro with Photo */}
        <div className="grid md:grid-cols-2 gap-16 items-center mb-20" data-id="element-16">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-17">
            <h2 className="text-4xl md:text-5xl font-serif text-ink-dark mb-6" data-id="element-18">
              Hola, soy Ingri. Y llevo 8 años haciendo una sola cosa:{' '}
              <span className="italic text-gold-dark" data-id="element-19">hacerte brillar.</span>
            </h2>
            <p className="font-sans text-lg text-ink-light mb-8 leading-relaxed" data-id="element-20">
              Soy artista lashista especialista. Estoy ubicada en Pasadena, HTX
              y he trabajado con cientos de mujeres que hoy no salen de casa sin
              su mirada firmada.
            </p>
            <div className="bg-white p-6 border-l-4 border-blush shadow-sm" data-id="element-21">
              <p className="font-serif text-xl text-ink-dark italic" data-id="element-22">
                "No tengo turno para todo el mundo. Tengo espacio para quien
                quiere hacerlo bien."
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex justify-center" data-id="element-23">
            <div className="relative" data-id="element-24">
              <div className="absolute -inset-4 border border-blush/60 rounded-lg" data-id="element-25" />
              <img src="https://cdn.magicpatterns.com/uploads/sTxSTubRaayzGbNDv7Car4/347071357_770677081388685_6260994644631912143_n.jpg" alt="Ingri - Lash Artist" className="w-80 h-96 object-cover object-top rounded-lg shadow-xl relative z-10" data-id="element-26" />
              <div className="absolute -bottom-3 -right-3 bg-gold text-white px-4 py-2 text-sm font-sans uppercase tracking-widest font-bold z-20 rounded-sm shadow-md" data-id="element-27">
                8 años de experiencia
              </div>
            </div>
          </motion.div>
        </div>

        {/* Services Grid */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="grid sm:grid-cols-2 md:grid-cols-4 gap-4" data-id="element-28">
          {services.map((service, idx) => {
          const Icon = service.icon;
          return <div key={idx} id={service.id} className="bg-white p-6 border border-gold/10 rounded-sm hover:border-blush hover:shadow-md transition-all duration-300 group scroll-mt-24" data-id="element-29">
                <div className="w-12 h-12 bg-cream-dark rounded-full flex items-center justify-center mb-4 shadow-sm border border-gold/10 group-hover:scale-110 transition-transform" data-id="element-30">
                  <Icon className="text-gold-dark" size={20} data-id="element-31" />
                </div>
                <h3 className="font-serif text-xl text-ink-dark mb-2" data-id="element-32">
                  {service.name}
                </h3>
                <p className="font-sans text-sm text-ink-light" data-id="element-33">
                  {service.description}
                </p>
              </div>;
        })}
        </motion.div>
      </div>
    </section>;
}